import { FC } from "react";
import { useTranslation } from "react-i18next";
import { LpiSummary as LpiSummaryType } from "./types";
import { formatNumber } from "../../utils/formatNumber";
import "./LpiSummary.scss";

interface LpiSummaryProps {
  summary: LpiSummaryType | null;
  isLoading: boolean;
}

const SKELETON_COUNT = 6;

const LpiSummary: FC<LpiSummaryProps> = ({ summary, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="lpi-summary">
        <div className="lpi-summary__grid">
          {Array.from({ length: SKELETON_COUNT }, (_, i) => (
            <div
              key={i}
              className="lpi-summary__card lpi-summary__card--loading"
              data-testid="lpi-summary-skeleton"
            >
              <div className="lpi-summary__skeleton lpi-summary__skeleton--value" />
              <div className="lpi-summary__skeleton lpi-summary__skeleton--label" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!summary) {
    return null;
  }

  const notAvailable = t("Not available");

  const summaryCards = [
    {
      label: t("Orders with LPI"),
      value: formatNumber(summary.total_orders, 0),
    },
    {
      label: t("Total Beladingsprestatie"),
      value: formatNumber(summary.total_beladingsprestatie, 2),
    },
    {
      label: t("Total Distance"),
      value: formatNumber(summary.total_add_km, 2),
    },
    {
      label: t("Overall LPI"),
      value:
        summary.overall_lpi !== null
          ? formatNumber(summary.overall_lpi, 6)
          : notAvailable,
    },
    {
      label: t("lpi.summary.averageEfficiency"),
      value:
        summary.average_efficiency !== null
          ? `${formatNumber(summary.average_efficiency, 2)}%`
          : notAvailable,
    },
    {
      label: t("lpi.summary.improvementPotential"),
      value:
        summary.improvement_potential !== null
          ? `${formatNumber(summary.improvement_potential, 2)}%`
          : notAvailable,
    },
  ];

  return (
    <div className="lpi-summary">
      <div className="lpi-summary__grid">
        {summaryCards.map((card) => (
          <div key={card.label} className="lpi-summary__card">
            <div className="lpi-summary__value">{card.value}</div>
            <div className="lpi-summary__label">{card.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LpiSummary;
